import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import "url-search-params-polyfill";
import { init } from "../../../components/EventLabel2/EventLabel2";
import { PollModuleContainer } from "./components/PollModuleContainer";
import { pollStyle } from "./poll.helper";
import { mockupQuestions } from "./mockup/mockupQuestion";
import { Badge, Fab, Tooltip } from "@material-ui/core";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import PollIcon from "@material-ui/icons/Poll";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import CloseIcon from "@material-ui/icons/Close";
import { escapeHTML } from "../../../helpers/stringHelper";

const defaultState = {
  answerList: [],
  questionList: [],
  sent: false,
  pageNo: 1,
};

function PollModule(props) {
  const [state, setState] = useState(defaultState);
  const [collapsed, setCollapsed] = useState(props.settings.collapsible);
  const { eventId, lang, hubConnection, elevateParentContainer = () => null, personTypes, connected, clientKey, clientName, companyName, preview, template } = props;

  const stateRef = useRef();

  stateRef.current = state;

  useEffect(() => {
    init(eventId, "DigitalMeeting.Client", lang);
    configureHubEvents();
    return () => null;
  }, []);
  useEffect(() => {
    if (hubConnection && !preview) {
      hubConnection.on("onGetActiveQuestions", onGetActiveQuestions);
      hubConnection.on("onActivateQuestion", onActivateQuestion);
      hubConnection.on("onDeactivateQuestion", onDeactivateQuestion);
    }
    return () => {
      if (hubConnection && !preview) {
        hubConnection.off("onGetActiveQuestions", onGetActiveQuestions);
        hubConnection.off("onActivateQuestion", onActivateQuestion);
        hubConnection.off("onDeactivateQuestion", onDeactivateQuestion);
      }
    };
  });
  const clearAnswerListByQuestionId = (questionId) => {
    const answerList = Array.from(stateRef.current.answerList).filter((al) => al.questionId !== questionId);
    setState({ ...stateRef.current, answerList });
  };
  const configureHubEvents = () => {
    if (hubConnection && !preview) {
      hubConnection.invoke("getClientQuestions", eventId, "INTERACTION_CLIENT");
    } else {
      const questionList = mockupQuestions;
      setState({ ...stateRef.current, questionList });
    }
  };
  const onTextInput = (questionId, value) => {
    let answerList = Array.from(stateRef.current.answerList);
    let answer = answerList.find((nl) => nl.questionId === questionId);
    const valid = value.length > 0 && value.length < 4000;
    if (answer) {
      answer.value = value;
      answer.valid = valid;
    } else {
      answerList.push({ questionId, value, valid });
    }

    setState({ ...stateRef.current, answerList });
  };
  const selectOption = (index, active, questionId) => {
    const question = stateRef.current.questionList.find((q) => q.question.questionId == questionId);
    let answerList = Array.from(stateRef.current.answerList);
    const { questionOption } = question.question;

    if (questionOption === undefined && !questionOption && questionOption !== typeof "Array") return null;

    const options = Array.from(questionOption);

    if (question.question.requiredMax === 0 && options.filter((o) => o.active === true).length === 1 && active === true) {
      options.map((o) => (o.active = false));
    }
    if (question.question.requiredMax === 1 && options.filter((o) => o.active === true).length === 1 && active === true) {
      options.map((o) => (o.active = false));
      answerList = answerList.filter((a) => a.questionId !== questionId);
    }

    options[index].active = active;
    question.question.questionOption = options;

    if (active) {
      answerList.push({ questionId, value: options[index].questionOptionId });
    } else {
      answerList = answerList.filter((a) => a.value !== options[index].questionOptionId);
    }

    const questionList = Array.from(
      stateRef.current.questionList.map((ql) => {
        if (ql.question.questionId === question.question.questionId) {
          ql = question;
        }
        return ql;
      })
    );
    setState({ ...stateRef.current, questionList, answerList });
  };

  const getAnsweredQuestions = (eventId) => {
    let answeredQuestions = localStorage.getItem("__JIAQ"); //JirangoInteractionAnsweredQuestions obfuscated!!
    if (answeredQuestions) {
      answeredQuestions = JSON.parse(answeredQuestions);
    } else {
      answeredQuestions = [];
    }
    if (eventId) {
      return answeredQuestions.filter((aq) => aq.eventId == eventId);
    } else {
      return answeredQuestions;
    }
  };
  const getAnsweredCount = (questionId) => {
    let questions = getAnsweredQuestions(eventId);
    return questions.filter((aq) => aq.questionId == questionId && (aq.clientKey == clientKey || !aq.clientKey)).length;
  };
  const addAnsweredQuestion = (aq) => {
    let answeredQuestions = getAnsweredQuestions();
    answeredQuestions.push(aq);
    localStorage.setItem("__JIAQ", JSON.stringify(answeredQuestions));
  };
  const removeAnsweredQuestion = (questionId) => {
    let questions = getAnsweredQuestions();
    questions = questions.filter((q) => q.questionId != questionId && (q.clientKey == clientKey || !q.clientKey));
    localStorage.setItem("__JIAQ", JSON.stringify(questions));
  };
  const onGetActiveQuestions = (clientQuestionList) => {
    let questionList = clientQuestionList;
    let pTypes = [];
    if (personTypes && personTypes.length > 0) {
      pTypes = personTypes;
      questionList = questionList.filter((q) => !pTypes.includes(q.question.personType));
    }
    questionList = questionList.filter((q) => {
      var count = getAnsweredCount(q.questionId);
      if (q.question.allowedAnswerCount && q.question.allowedAnswerCount <= count) {
        return false;
      } else {
        return true;
      }
    });
    setState({
      ...stateRef.current,
      questionList,
    });
  };
  const onActivateQuestion = (clientQuestion, sendTime) => {
    const questionList = Array.from(stateRef.current.questionList);
    if (clientQuestion.allowedAnswerCount) {
      clientQuestion.question.allowedAnswerCount = clientQuestion.allowedAnswerCount;
    }
    removeAnsweredQuestion(clientQuestion.question.questionId);
    questionList.push(clientQuestion);
    setState({
      ...stateRef.current,
      questionList,
      answer: "",
    });
  };
  const onDeactivateQuestion = (clientQuestion, shouldNotRemove) => {
    let pageNo = stateRef.current.pageNo;
    let questionList = Array.from(stateRef.current.questionList);
    let q = questionList.find((q) => q.question.questionId == clientQuestion.question.questionId);
    if (q) {
      if (!shouldNotRemove) removeAnsweredQuestion(q.question.questionId);
      questionList = questionList.filter((ql) => ql.question.questionId != clientQuestion.question.questionId);
      pageNo = pageNo > 1 ? pageNo - 1 : 1;
      setState({
        ...stateRef.current,
        questionList,
        pageNo,
      });
    }
  };
  const sendOptions = (answers, question, questionId) => {
    let answerList = Array.from(stateRef.current.answerList);
    let questionList = Array.from(stateRef.current.questionList);
    let pageNo = stateRef.current.pageNo;
    addAnsweredQuestion({
      clientKey,
      questionId,
      type: question.question.type,
      eventId,
      answer: "",
      answerTime: new Date(Date.now()).toISOString(),
    });

    answers.map((answer) => {
      if (answer) {
        hubConnection
          .invoke("clientResponse", {
            questionId,
            type: question.question.type,
            eventId,
            clientKey,
            answer: answer.value,
            clientName: clientName ? (companyName || "") + " " + clientName : "Guest_" + clientKey.toString().substr(0, 8),
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
    let answerCount = getAnsweredCount(questionId);
    if (question.question.allowedAnswerCount === null || question.question.allowedAnswerCount <= answerCount) {
      questionList = questionList.filter((ql) => ql.question.questionId != questionId);
      pageNo = pageNo > 1 ? pageNo - 1 : 1;
    }
    answerList = answerList.filter((q) => q.questionId != questionId);

    setState({
      ...stateRef.current,
      questionList,
      answerList,
      pageNo,
      sent: true /* pageNo: stateRef.current.pageNo - 1   */,
    });
    setTimeout(() => setState({ ...stateRef.current, sent: false }), 3000);
  };
  const send = (questionId, optionId) => {
    if (!connected || !hubConnection || hubConnection.connectionState != 1) return;
    let questionList = Array.from(stateRef.current.questionList);
    let pageNo = stateRef.current.pageNo;
    let answerList = Array.from(stateRef.current.answerList);
    let question = questionList.find((ql) => ql.question.questionId === questionId);

    if (answerList.length > 1 && question.question.type == "Option") {
      return sendOptions(
        answerList.filter((al) => al.questionId == questionId),
        question,
        questionId
      );
    }

    let answer = answerList.find((al) => al.questionId == questionId);
    addAnsweredQuestion({
      clientKey,
      questionId,
      type: question.question.type,
      eventId,
      answer: optionId ? optionId : answer ? answer.value : "",
      answerTime: new Date(Date.now()).toISOString(),
    });

    if (!optionId && !answer) return;
    hubConnection
      .invoke("clientResponse", {
        questionId,
        type: question.question.type,
        eventId,
        clientKey,
        answer: optionId ? optionId : escapeHTML(answer.value),
        clientName: clientName ? (companyName || "") + " " + clientName : "Guest_" + clientKey.toString().substr(0, 8),
      })
      .catch((error) => {
        console.error(error);
      });
    let answerCount = getAnsweredCount(questionId);
    if (question.question.allowedAnswerCount === null || question.question.allowedAnswerCount <= answerCount) {
      /*  onDeactivateQuestion(question, true); */
      questionList = questionList.filter((ql) => ql.question.questionId != questionId);
      pageNo = pageNo > 1 ? pageNo - 1 : 1;
    }
    answerList = answerList.filter((q) => q.questionId != questionId);

    setState({
      ...stateRef.current,
      questionList,
      answerList,
      sent: true /* pageNo: stateRef.current.pageNo - 1  */,
    });
    setTimeout(() => setState({ ...stateRef.current, sent: false }), 3000);
  };
  const togglePage = (pageNo) => setState({ ...stateRef.current, pageNo });
  const api = {
    send,
    ...props,
    ...state,
    selectOption,
    togglePage,
    onTextInput,
    pollTemplate: pollStyle(template),
  };

  const { placeholder } = api.pollTemplate;

  if ((props.settings.collapsible && collapsed) || (props.settings.collapsible && preview)) {
    return (
      <Fab
        style={{ background: placeholder.iconBackgroundColor, left: "5px", top: "calc(100% - 65px)", position: "absolute" }}
        aria-label="chat-fab"
        onClick={() => {
          setCollapsed(!collapsed);
          elevateParentContainer(collapsed);
        }}
      >
        <div
          className="badge-pill"
          style={{
            background: placeholder.color,
            display: state.questionList.length > 0 ? "block" : "none",
          }}
        />

        <PollIcon style={{ color: placeholder.iconColor }} />
      </Fab>
    );
  }
  return (
    <>
      {props.settings.collapsible ? (
        <div
          className="chat-close-arrow"
          onClick={() => {
            setCollapsed(!collapsed);
            elevateParentContainer(collapsed);
          }}
        >
          <Tooltip title={<SystemLabel name="CollapsePoll" />}>
            <Fab style={{ background: placeholder.iconBackgroundColor }}>
              <CloseIcon style={{ color: placeholder.iconColor }} />
            </Fab>
          </Tooltip>
        </div>
      ) : null}
      <PollModuleContainer {...api} />
    </>
  );
}

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : null,
  };
}
export default connect(mapStateToProps)(PollModule);
